import { isAxiosError } from "axios";

import { notify } from "../../lib/notify";

type Params = {
  message?: string;
  details?: Record<string, unknown>;
  overrideMessage?: string;
};

/**
 * errから適切なメッセージを表示、ログ出力する
 */
export const handleError = (err: unknown, opt?: Params) => {
  console.error({
    message: opt?.message ?? "no message",
    details: opt?.details ?? "no detail",
    err: {
      message: (err as any)?.message,
      code: (err as any)?.code,
      response: (err as any)?.response?.data?.error,
    },
  });
  if (opt?.overrideMessage) {
    notify(opt.overrideMessage, "error");
    return;
  }

  if (isAxiosError(err)) {
    // HTTPリクエストエラーの場合
    let errMessage: string | undefined = undefined;

    // サーバーからエラーメッセージが返ってきた場合
    if (err.response?.data?.error?.message) {
      errMessage = err.response?.data?.error?.message;
    }

    // タイムアウト
    if (err.code === "ECONNABORTED") {
      errMessage = "サーバーが応答しませんでした。再度お試しください。";
    }

    notify(errMessage ?? "ネットワークエラーが発生しました。", "error");
    return;
  } else if (err instanceof Error) {
    // スナックバーは固定
    notify(
      err.message ?? "エラーが発生しています。再度お試しください。",
      "error"
    );
    return;
  }

  // スナックバーは固定
  notify("不明なエラーが発生しています。再度お試しください。", "error");
};
